import React from "react";
import "@/App.css";
import { I18nProvider } from "@/i18n/I18nContext";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import VideoSection from "@/components/VideoSection";
import StorySection from "@/components/StorySection";
import FormsSection from "@/components/FormsSection";
import PlanetsSection from "@/components/PlanetsSection";
import ControlsSection from "@/components/ControlsSection";
import SpecsSection from "@/components/SpecsSection";
import Footer from "@/components/Footer";

function App() {
  return (
    <I18nProvider>
      <div className="App relative">
        {/* CRT overlays */}
        <div className="crt-overlay" aria-hidden="true" />
        <div className="crt-vignette" aria-hidden="true" />
        <div className="crt-grain" aria-hidden="true" />

        <Header />
        <main data-testid="main-content">
          <Hero />
          <VideoSection />
          <StorySection />
          <FormsSection />
          <PlanetsSection />
          <ControlsSection />
          <SpecsSection />
        </main>
        <Footer />
      </div>
    </I18nProvider>
  );
}

export default App;
